import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckBoxInput from '../../components/StewardAssetEdit/CheckBoxInput';
import { ActivityProps } from '../../props/activity';
import { getRef, addChange, clearChange } from '../../actions/changes';

const propTypes = {
  activity: ActivityProps,
  value: PropTypes.shape({
    activityId: PropTypes.number,
    assetId: PropTypes.string,
    name: PropTypes.string
  }),
  activityType: PropTypes.string,
  getRef: PropTypes.func.isRequired,
  addChange: PropTypes.func.isRequired,
  clearChange: PropTypes.func.isRequired
};

const defaultProps = {
  value: null
};

export class ActivityOption extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.value !== null,
      ref: this.props.getRef(this.props.activityType, this.props.value || {})
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { value: checked } = event.target;
    const { activity: { id: activityId }, value } = this.props;
    const { ref } = this.state;

    if (checked && value === null) {
      this.setState({ checked }, () => this.props.addChange(ref, { activityId }));
    }
    else if (value !== null) {
      this.setState({ checked }, () => this.props.addChange(ref, { _delete: true }));
    }
    else {
      this.setState({ checked }, () => this.props.clearChange(ref));
    }
  }

  render() {
    const { activity } = this.props;
    const { checked } = this.state;

    return (
      <CheckBoxInput
        value={checked}
        onChange={this.handleChange}
        label={activity.name}
        field={`activity-${activity.name}`} />
    );
  }
}

ActivityOption.propTypes = propTypes;
ActivityOption.defaultProps = defaultProps;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getRef,
  addChange,
  clearChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ActivityOption);
